import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { client } from './config';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/react-hooks';
import { registerUnhandledRejectionHandler } from './tracking/newrelic';

registerUnhandledRejectionHandler();

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter basename={'/'} >
      <App />
    </BrowserRouter>
  </ApolloProvider>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
